module.exports = __webpack_public_path__ + "static/media/angle-down.87b8919a.svg";